import { render } from "./course-schema.vue?vue&type=template&id=0734a175&scoped=true"
import script from "./course-schema.vue?vue&type=script&lang=ts"
export * from "./course-schema.vue?vue&type=script&lang=ts"

import "./course-schema.vue?vue&type=style&index=0&id=0734a175&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0734a175"

export default script